export default {
  aboutServiceContent: {
    subtitle: "خدماتنا",

    title1: "خدمات احترافية",
    title2: "للأغذية B2B",

    desc:
      "تقدم MAHAL خدمات موثوقة وشفافة لتوريد المواد الغذائية مخصصة للمطاعم والشركات.",

    text:
      "نعمل مع موردين موثوقين وشركاء لوجستيين لضمان الجودة والتوصيل في الوقت المحدد.",

    f1: "توصيل 24/7",
    f2: "شبكة موردين قوية",
    f3: "منتجات عالية الجودة",
    f4: "توفر واسع للمنتجات",

    cta1: "عرض الخدمات",
    cta2: "اتصل بنا",
  },
};